<template>
  <div id="app" class="shane_tm_all_wrap">
    <router-view></router-view>
    <back-top :class="{mailpActive: mailPActive}" color="#fff" :size="1.2" bottom="5%" :slow="0"> </back-top>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowWidth: 0
    }
  },
  mounted() {
    document.body.classList.add("loaded")
    console.log('mounted')
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
    setTimeout(() => {
      this.windowWidth = window.innerWidth
    }, 200)
    // this.onResize()
  },
  watch: {
    windowWidth(newWidth) {
      this.$store.commit('UPDATE_WINDOW_WIDTH', newWidth)
    },
  },
  destroyed() {
    document.body.classList.remove("loaded");
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize)
  },
  methods: {  
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  computed: {
    mailPActive() {
      return this.$store.getters.GetMailPActive
    },
  }
};
</script>

<style lang="scss">
.v-lazy-image {
  filter: blur(10px);
  transition: filter 0.7s;
}
.v-lazy-image-loaded {
  filter: blur(0);
}
.back-top {
  transition: all .5s ease;
  opacity: 1;
}
.back-top.mailpActive {
  right: -200px !important;
  opacity: 0;
}
.back-top {
  z-index: 99;
}
.back-top__icon {
  color: #000 !important;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px !important;
  font-size: 20px !important;
}
</style>

<style lang="css">
.slick-prev:before, .slick-next:before {
  color: black !important;
}
.cursor-pointer:hover {
  cursor: pointer;
}
@font-face {
  font-family: "CopperplateBold";
  src: local("CopperplateBold"),
   url('~@/assets/fonts/CopperplateBold.ttf') format("truetype");
}
@font-face {
  font-family: "HelveticaCondensed";
  src: local("HelveticaCondensed"),
   url('~@/assets/fonts/helvetica_condensed.ttf') format("truetype");
}
@font-face {
  font-family: "Helvetica";
  src: local("Helvetica"),
   url('~@/assets/fonts/Helvetica.ttf') format("truetype");
}
@font-face {
  font-family: "HelveticaLight";
  src: local("HelveticaLight"),
   url('~@/assets/fonts/HelveticaLight.ttf') format("truetype");
}
@font-face {
  font-family: "HelveticaBold";
  src: local("HelveticaBold"),
   url('~@/assets/fonts/HelveticaBold.ttf') format("truetype");
}
@font-face {
  font-family: "HelveticaLightOblique";
  src: local("HelveticaLightOblique"),
   url('~@/assets/fonts/HelveticaLightOblique.ttf') format("truetype");
}
</style>